type ScanFormOptionsRequirements = {
  integrations: unknown[];
  workerPools: unknown[];
  loading: boolean;
  error: unknown;
};

export const getMissingScanRequirements = (
  formOptions: ScanFormOptionsRequirements,
  spaceId: string | undefined
) => {
  const hasLoadedRequirements = !!spaceId && !formOptions.loading && !formOptions.error;

  return {
    hasNoAttachableIntegration: hasLoadedRequirements && formOptions.integrations.length === 0,
    hasNoAttachableWorkerPool: hasLoadedRequirements && formOptions.workerPools.length === 0,
  };
};
